module.exports = __webpack_public_path__ + "img/blueTabbBD.05e14508.svg";